module.exports = __webpack_public_path__ + "img/811.037f4df1.png";